import React from 'react';

import {
  Flex,
  Text,
  icons,
} from 'web-styled';

import Item from './Item';
import * as S from './styled';

type Props = {
  items?: any[],
  basePath?: string,
  resourceType: string,
  onSave: { (item: any): void },
  onEnterResults: { (item: any): void },
};

const PersonalEntityList = ({
  items,
  basePath,
  resourceType,
  onSave,
  onEnterResults,
}: Props) => (
  <Flex
    column
    fillSpace
    width="100%"
  >
    {items?.length ? items.map(entity => (
      <Item
        key={entity.id}
        entity={entity}
        basePath={basePath}
        onSave={onSave}
        onEnterResults={onEnterResults}
        resourceType={resourceType}
      />
    )) : (
      <S.Empty>
        <img src={icons.folder} alt="" />
        <Text color="#ccc">
          You dont have
          <br />
          anything inside this folder.
        </Text>
      </S.Empty>
    )}
  </Flex>
);

PersonalEntityList.defaultProps = {
  items: [],
  basePath: '/',
};

export default PersonalEntityList;
